export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 prose prose-sm dark:prose-invert">
      <h1>Privacy Policy</h1>
      <p><em>Last updated: May 12, 2026</em></p>

      <h2>1. Who We Are</h2>
      <p>
        RepairApp ("we", "us", "our") is a fleet and equipment maintenance management platform
        operated by American Rail Center. This Privacy Policy describes how we collect, use, and
        protect your information when you use our service.
      </p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li><strong>Account information:</strong> name, email address, phone number, and role within your organization.</li>
        <li><strong>Usage data:</strong> repair requests, parts orders, PM assignments, and audit logs you create or interact with.</li>
        <li><strong>Device &amp; log data:</strong> IP address, browser type, and timestamps when you access the service.</li>
        <li><strong>Consent records:</strong> date/time you accepted these terms and whether you opted into SMS notifications.</li>
      </ul>

      <h2>3. SMS Messaging Program</h2>
      <p>
        If you opt in to SMS notifications, we may send you text messages about repair orders,
        preventive maintenance alerts, and parts order updates. Message frequency varies based on
        your organization's activity. Message and data rates may apply.
      </p>
      <p>
        <strong>To stop receiving SMS messages,</strong> reply <strong>STOP</strong> to any message we send.
        You may also update your consent in your account settings. After opting out, you may receive
        one final confirmation message.
      </p>
      <p>
        For help, reply <strong>HELP</strong> or contact us at{' '}
        <a href="mailto:support@americanrailcenter.com">support@americanrailcenter.com</a>.
      </p>

      <h2>4. How We Use Your Information</h2>
      <ul>
        <li>To operate and provide the RepairApp service.</li>
        <li>To send transactional notifications you have requested (email or SMS).</li>
        <li>To maintain audit logs for compliance and accountability.</li>
        <li>To improve reliability and fix bugs.</li>
      </ul>

      <h2>5. Data Sharing</h2>
      <p>
        We do not sell your personal information. We share data only with:
      </p>
      <ul>
        <li><strong>AWS:</strong> hosting, email (SES), SMS (SNS), and storage (S3).</li>
        <li><strong>Stripe:</strong> subscription billing.</li>
        <li>Law enforcement when required by law.</li>
      </ul>

      <h2>6. Data Retention</h2>
      <p>
        We retain your account data for as long as your organization's account is active. Audit logs
        are retained for a minimum of 2 years. You may request deletion by contacting us.
      </p>

      <h2>7. Security</h2>
      <p>
        Data is encrypted in transit (TLS) and at rest. Access is restricted by role-based permissions.
        We follow AWS security best practices.
      </p>

      <h2>8. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have the right to access, correct, or delete your
        personal data. Contact{' '}
        <a href="mailto:support@americanrailcenter.com">support@americanrailcenter.com</a> to submit
        a request.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        American Rail Center<br />
        <a href="mailto:support@americanrailcenter.com">support@americanrailcenter.com</a>
      </p>
    </div>
  );
}
